module.exports = __webpack_public_path__ + "img/t2.7191c120.png";